import { render, staticRenderFns } from "./ComplexBuildingWrite.vue?vue&type=template&id=8803edb2&scoped=true"
import script from "./ComplexBuildingWrite.vue?vue&type=script&lang=js"
export * from "./ComplexBuildingWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8803edb2",
  null
  
)

export default component.exports